module.exports = __webpack_public_path__ + "img/floppy-disk-pen.950eb9ee.svg";